import React from "react";
import { Link } from "react-router-dom";
import {
  FaArrowDown,
  FaArrowUp,
  FaDownload,
  FaPlayCircle,
  FaRunning,
  FaStar,
} from "react-icons/fa";
import Header from "components/Header";
import Footer from "components/Footer";
import playerImage from "../../assets/img/pictures/PP.png";
import coverImage from "../../assets/img/pictures/cc.png";

const profileData = {
  id: 1,
  name: "George Abban",
  nationality: "Ghanaian",
  role: "Center Forward",
  number: "#9",
  age: 15,
  height: "184 cm",
  weight: "76 kg",
  foot: "Right (Left 4*)",
  tier: "Elite Prospect • U-19",
  goals: 24,
  goalsDelta: "+15% vs Last Season",
  assists: 12,
  appearances: 18,
  rating: "A+",
  quote: '"A generational talent with a tactical brain beyond his years."',
  keyStrength: "Finishing",
  growthArea: "Defensive Press",
  topSpeed: "34.2",
  passing: 89,
  workRate: 85,
  image: playerImage,
};

const attributes = [
  { label: "Pace", value: 92 },
  { label: "Dribbling", value: 88 },
  { label: "Vision", value: 95 },
  { label: "Stamina", value: 84 },
];

const timeline = [
  {
    date: "JAN 2024",
    title: "Kempshot Elite Debut",
    description:
      "Scored a hat-trick on debut against Northern Academy. Awarded Man of the Match.",
    dotClass: "bg-green-500",
  },
  {
    date: "SEPT 2023",
    title: "International Call-up",
    description:
      "Selected for England U-18 National Team European qualifiers.",
    dotClass: "bg-navy-900",
  },
  {
    date: "MAY 2023",
    title: "Academy Scholarship",
    description:
      "Signed full-term development scholarship at Kempshot Sports Academy.",
    dotClass: "bg-gray-400",
  },
];

const PlayerProfileDetail = () => {
  const profile = profileData;

  return (
    <div className="min-h-screen text-gray-900">
      <div className="fixed inset-0 z-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95" />
      <div className="relative z-10">
      <Header />

      <main className="pt-20">
        <section className="relative min-h-[580px] overflow-hidden">
          <div className="absolute inset-0">
            <img src={coverImage} alt="Player cover" className="h-full w-full object-cover object-[center_30%]" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/50 to-transparent" />
          </div>

          <div className="relative mx-auto flex min-h-[580px] max-w-7xl items-end px-4 pb-14 sm:px-6 lg:px-8">
            <div className="w-full">
              <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
                <div className="flex items-end gap-5">
                  <div className="h-28 w-28 overflow-hidden rounded-xl border-4 border-white/80 bg-white/20 shadow-lg sm:h-32 sm:w-32">
                    <img src={profile.image} alt={profile.name} className="h-full w-full object-cover" />
                  </div>

                  <div>
                  <span className="mb-5 inline-flex rounded-sm bg-green-500 px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">
                    {profile.tier}
                  </span>
                  <h1 className="text-5xl font-extrabold uppercase text-white sm:text-6xl">{profile.name}</h1>
                  <div className="mt-3 flex items-center gap-5 text-white/90">
                    <span className="text-base font-semibold uppercase text-green-200 sm:text-lg">{profile.nationality}</span>
                    <span className="hidden h-6 w-px bg-white/30 sm:block" />
                    <span className="text-xl font-bold uppercase italic sm:text-2xl">{profile.role}</span>
                    <span className="hidden h-6 w-px bg-white/30 sm:block" />
                    <span className="text-2xl font-bold">{profile.number}</span>
                  </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-3">
                  <a
                    href="https://youtube.com"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 rounded-lg bg-blue-800 px-6 py-4 text-sm font-bold uppercase tracking-wide text-blue-100 transition hover:bg-blue-700"
                  >
                    <FaPlayCircle /> Watch Highlights
                  </a>
                  <button
                    type="button"
                    className="flex items-center gap-2 rounded-lg border-2 border-white px-6 py-4 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-white hover:text-navy-900"
                  >
                    <FaDownload /> Download Scout CV
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
            <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm md:col-span-4">
              <h3 className="mb-8 flex items-center gap-2 text-2xl font-bold text-navy-900">Physical Profile</h3>
              <div className="space-y-5">
                <div className="flex items-center justify-between border-b border-gray-200 pb-3">
                  <span className="text-xs font-bold uppercase tracking-widest text-gray-500">Age</span>
                  <span className="font-semibold">{profile.age} Years</span>
                </div>
                <div className="flex items-center justify-between border-b border-gray-200 pb-3">
                  <span className="text-xs font-bold uppercase tracking-widest text-gray-500">Height</span>
                  <span className="font-semibold">{profile.height}</span>
                </div>
                <div className="flex items-center justify-between border-b border-gray-200 pb-3">
                  <span className="text-xs font-bold uppercase tracking-widest text-gray-500">Weight</span>
                  <span className="font-semibold">{profile.weight}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold uppercase tracking-widest text-gray-500">Preferred Foot</span>
                  <span className="font-semibold text-green-700">{profile.foot}</span>
                </div>
              </div>
              <div className="mt-8 rounded-lg border-l-4 border-navy-900 bg-blue-50 p-4 text-sm italic text-gray-600">
                "Exceptional aerial presence combined with a low center of gravity for rapid transitions."
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 md:col-span-8 sm:grid-cols-2">
              <div className="rounded-xl bg-navy-900 p-8 text-white shadow-sm">
                <div className="flex items-start justify-between">
                  <span className="text-xs font-bold uppercase tracking-widest text-blue-200">Season Goals</span>
                  <FaRunning className="text-2xl text-green-300" />
                </div>
                <div className="mt-8 text-6xl font-extrabold leading-none">{profile.goals}</div>
                <div className="mt-3 flex items-center gap-2 text-sm font-bold text-green-300">
                  <FaArrowUp />
                  {profile.goalsDelta}
                </div>
              </div>

              <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
                <div className="text-xs font-bold uppercase tracking-widest text-gray-500">Assists</div>
                <div className="mt-8 text-6xl font-extrabold leading-none text-navy-900">{profile.assists}</div>
                <div className="mt-3 text-sm font-semibold text-gray-600">Across {profile.appearances} Appearances</div>
              </div>

              <div className="rounded-xl bg-green-700 p-8 text-white sm:col-span-2">
                <div className="grid items-center gap-8 md:grid-cols-[1fr_auto]">
                  <div>
                    <h4 className="mb-4 text-2xl font-bold uppercase">Attributes Radar</h4>
                    <div className="grid gap-4 sm:grid-cols-2">
                      {attributes.map((item) => (
                        <div key={item.label}>
                          <div className="mb-1 flex items-center justify-between text-xs font-bold uppercase tracking-widest">
                            <span>{item.label}</span>
                            <span>{item.value}</span>
                          </div>
                          <div className="h-2 w-full overflow-hidden rounded-full bg-green-900/40">
                            <div
                              className="h-full rounded-full bg-white"
                              style={{ width: `${item.value}%` }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="relative flex h-32 w-32 items-center justify-center rounded-2xl border-4 border-white/30 text-4xl font-extrabold md:h-40 md:w-40">
                    {profile.rating}
                    <span className="absolute inset-2 rounded-xl border border-white/30" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-gray-200 py-20">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid gap-12 md:grid-cols-[1fr_2fr]">
              <div>
                <h2 className="text-5xl font-extrabold uppercase leading-tight text-navy-900">Career Timeline</h2>
                <p className="mt-6 text-gray-600">
                  Tracking {profile.name.split(" ")[0]}'s rapid ascent from local leagues to elite academy performance.
                </p>
                <div className="mt-10 rounded-xl bg-white p-4 shadow-sm">
                  <p className="text-sm font-bold text-navy-900">Previous Club</p>
                  <p className="text-xs text-gray-500">Manchester City Youth (2021-23)</p>
                </div>
              </div>

              <div className="relative">
                <div className="absolute bottom-0 left-3 top-0 w-[2px] bg-gray-400" />
                <div className="space-y-8">
                  {timeline.map((event) => (
                    <article key={event.title} className="relative pl-10">
                      <span className={`absolute left-0 top-6 h-6 w-6 rounded-full border-4 border-gray-200 ${event.dotClass}`} />
                      <div className="rounded-xl bg-white p-6 shadow-sm">
                        <p className="text-xs font-bold uppercase tracking-widest text-gray-500">{event.date}</p>
                        <h4 className="mt-2 text-xl font-bold text-navy-900">{event.title}</h4>
                        <p className="mt-2 text-gray-600">{event.description}</p>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-[2rem] bg-navy-900 p-8 text-white md:p-14">
            <div className="absolute right-8 top-0 hidden h-full w-40 opacity-10 md:block">
              <div className="grid h-full grid-cols-3 gap-6">
                <div className="h-full bg-white" />
                <div className="h-full bg-white" />
                <div className="h-full bg-white" />
              </div>
            </div>

            <div className="relative grid gap-10 lg:grid-cols-2">
              <div>
                <div className="mb-7 flex items-center gap-4">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full border-4 border-green-300 bg-white/10 text-lg font-bold text-green-200">
                    KSA
                  </div>
                  <div>
                    <p className="text-2xl font-bold">David McAllister</p>
                    <p className="text-xs font-bold uppercase tracking-widest text-green-300">Head of Recruitment</p>
                  </div>
                </div>

                <h3 className="text-4xl font-extrabold uppercase italic leading-tight">{profile.quote}</h3>

                <p className="mt-7 text-blue-100/90">
                  {profile.name.split(" ")[0]} demonstrates a rare combination of physical power and technical finesse. His spatial awareness in the final third allows him to find pockets of space that other players miss.
                </p>

                <div className="mt-8 grid grid-cols-2 gap-6 border-t border-white/10 pt-6">
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-green-300">Key Strength</p>
                    <p className="mt-2 text-xl font-bold">{profile.keyStrength}</p>
                  </div>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-green-300">Growth Area</p>
                    <p className="mt-2 text-xl font-bold">{profile.growthArea}</p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
                  <p className="text-xs font-bold uppercase tracking-widest text-green-300">Passing Accuracy</p>
                  <p className="mt-4 text-4xl font-extrabold">{profile.passing}%</p>
                  <div className="mt-4 h-1.5 w-full rounded-full bg-white/20">
                    <div className="h-full rounded-full bg-green-300" style={{ width: `${profile.passing}%` }} />
                  </div>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
                  <p className="text-xs font-bold uppercase tracking-widest text-green-300">Top Speed</p>
                  <p className="mt-4 text-4xl font-extrabold">
                    {profile.topSpeed} <span className="text-sm font-semibold">km/h</span>
                  </p>
                  <div className="mt-4 h-1.5 w-full rounded-full bg-white/20">
                    <div className="h-full w-[94%] rounded-full bg-green-300" />
                  </div>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
                  <p className="text-xs font-bold uppercase tracking-widest text-green-300">Decision Making</p>
                  <p className="mt-4 text-4xl font-extrabold">Elite</p>
                  <div className="mt-4 flex items-center gap-1 text-green-300">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
                  <p className="text-xs font-bold uppercase tracking-widest text-green-300">Work Rate</p>
                  <p className="mt-4 text-4xl font-extrabold">High</p>
                  <div className="mt-4 h-1.5 w-full rounded-full bg-white/20">
                    <div className="h-full rounded-full bg-green-300" style={{ width: `${profile.workRate}%` }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-between gap-4">
            <Link
              to="/auth/directory"
              className="inline-flex items-center gap-2 rounded-md border border-navy-900 px-5 py-3 text-sm font-bold uppercase tracking-wide text-navy-900 transition hover:bg-navy-900 hover:text-white"
            >
              <FaArrowDown className="rotate-90" />
              Back To Directory
            </Link>
          </div>
        </section>
      </main>

      <Footer />
      </div>
    </div>
  );
};

export default PlayerProfileDetail;
